import React from "react";
import PolicyPage from "@/pages/PolicyPage";

export default function PrivacyPolicy() {
  return (
    <PolicyPage
      title="Privacy Policy"
      sections={[
        {
          paragraphs: [
            "T&J Clinical Solutions respects client privacy and is committed to protecting personal information submitted through our website, booking forms, emails, phone calls, and service requests.",
          ],
        },
        {
          heading: "Information We Collect",
          paragraphs: ["Information collected may include:"],
          bullets: [
            "name",
            "phone number",
            "email address",
            "service address",
            "appointment details",
            "provider/facility information",
          ],
        },
        {
          heading: "How We Use Your Information",
          paragraphs: ["Information is used strictly for:"],
          bullets: [
            "scheduling",
            "communication",
            "customer support",
            "operational services",
            "billing/payment coordination",
          ],
        },
        {
          heading: "We Do Not Sell Your Information",
          paragraphs: [
            "T&J Clinical Solutions does not sell personal information to third parties.",
          ],
        },
        {
          heading: "When Information May Be Shared",
          paragraphs: [
            "Information may be shared only when necessary to provide requested services, process payments, comply with legal obligations, or support operational needs.",
          ],
        },
      ]}
    />
  );
}
